import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 4 }
const _hoisted_2 = {
  key: 1,
  class: "viewer-wrapper"
}
const _hoisted_3 = { key: 5 }
const _hoisted_4 = {
  key: 7,
  class: "carousel-counter"
}

import { Swiper, SwiperSlide } from "swiper/vue";
import { IonIcon } from "@ionic/vue";
import { chevronBackOutline, chevronForwardOutline } from "ionicons/icons";
import VideoViewer from "@/modules/a.worksheets/views/components/VideoViewer.vue";
import ImageViewer from "@/modules/a.worksheets/views/components/ImageViewer.vue";
import AudioPlayer from "@/modules/a.worksheets/views/components/AudioPlayer.vue";
import { IFile } from "@/modules/a.worksheets/stores/worksheetDataStore";
import PdfViewer from "@/globals/components/PdfViewer/PdfViewer.vue";
import { useWorksheetHandler } from "@/globals/helpers/worksheetHandler";
import { computed, ref, toRefs, watch } from "vue";
import { useDeviceStatus } from "@/stores/deviceStatus";
import {
  getViewerType,
  MimeType,
  resolveMimeType,
} from "@/globals/helpers/media/mimeTypeUtils";
import { IFileResolved, useIFileResolver } from "@/modules/a.worksheets/helpers/useIFileResolver";

type TSwiper = typeof Swiper;


export default /*@__PURE__*/_defineComponent({
  __name: 'WksMediaModalCarousel',
  props: {
  files: { type: Array<IFileResolved>, default: () => [] },
  slidesPerView: { type: Number, default: () => 1 },
  zoomable: { type: Boolean, default: () => true },
  initialSlide: { type: Number, default: () => 0 },
  // opt-in: lets the web viewer navigate between multiple files (arrows + counter,
  // honoring initialSlide). Defaults to off so every existing caller keeps the
  // original behavior of always showing files[0] on web.
  enableWebCarousel: { type: Boolean, default: () => false },
},
  emits: ["getPopUp", "getSwiper"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const wksHandler = useWorksheetHandler();
const setSwiperRef = (swiper: TSwiper) => emit("getSwiper", swiper);

const { isWeb } = toRefs(useDeviceStatus());

// only relevant to the web viewer-wrapper branch: the mobile Swiper handles its
// own current slide internally and already supports swiping between files
const currentIndex = ref(props.initialSlide ?? 0);
watch(
  () => props.initialSlide,
  (value) => {
    currentIndex.value = value ?? 0;
  },
);
const currentFile = computed(() => {
  if (!props.enableWebCarousel) return props.files?.[0];
  return props.files?.[currentIndex.value] ?? props.files?.[0];
});

function goPrev() {
  if (!props.files?.length) return;
  currentIndex.value = (currentIndex.value - 1 + props.files.length) % props.files.length;
}

function goNext() {
  if (!props.files?.length) return;
  currentIndex.value = (currentIndex.value + 1) % props.files.length;
}

const rotation = ref(0);
function rotate() {
  rotation.value += 90;
  if (rotation.value === 360) {
    rotation.value = 0;
  }
  console.log("rotation value: ", rotation.value);
}

__expose({
  rotate,
});

const currentPage = ref(1);


const handlePageChanged = (page: number) => {
  currentPage.value = page;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isWeb))
      ? (_openBlock(), _createBlock(_unref(Swiper), {
          key: 0,
          id: "swiper",
          "space-between": 20,
          "grab-cursor": true,
          autoplay: { delay: 3000 },
          speed: 400,
          "initial-slide": __props.initialSlide,
          "slides-per-view": __props.slidesPerView
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.files, (file, key) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                key: key,
                onSwiper: setSwiperRef,
                class: "swiperSlide"
              }, {
                default: _withCtx(() => [
                  (_unref(getViewerType)(file?.type ?? '') === 'pdf')
                    ? (_openBlock(), _createBlock(PdfViewer, {
                        key: key +
        _unref(wksHandler).$.task.uuid.value +
        _unref(wksHandler).$.activity.uuid.value +
        '_modal'
        ,
                        source: file.source,
                        id: "modal",
                        zoomable: __props.zoomable,
                        rotation: rotation.value,
                        "is-scroll": true,
                        page: currentPage.value,
                        onPageChanged: handlePageChanged
                      }, null, 8, ["source", "zoomable", "rotation", "page"]))
                    : _createCommentVNode("", true),
                  (_unref(getViewerType)(file?.type ?? '') === 'video')
                    ? (_openBlock(), _createBlock(VideoViewer, {
                        key: 1,
                        source: file.source,
                        zoomable: false
                      }, null, 8, ["source"]))
                    : _createCommentVNode("", true),
                  (_unref(getViewerType)(file?.type ?? '') === 'image')
                    ? (_openBlock(), _createBlock(ImageViewer, {
                        key: 2,
                        source: file.source,
                        zoomable: __props.zoomable,
                        rotation: rotation.value
                      }, null, 8, ["source", "zoomable", "rotation"]))
                    : _createCommentVNode("", true),
                  (_unref(getViewerType)(file?.type ?? '') === 'audio')
                    ? (_openBlock(), _createBlock(AudioPlayer, {
                        key: 3,
                        source: file.source,
                        type: file.type,
                        thumbnail: "/assets/Soundwave.svg",
                        zoomable: false
                      }, null, 8, ["source", "type"]))
                    : _createCommentVNode("", true),
                  (_unref(getViewerType)(file?.type ?? '') === 'other')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["initial-slide", "slides-per-view"]))
      : _createCommentVNode("", true),
    (_unref(isWeb))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.enableWebCarousel && __props.files.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "carousel-nav carousel-nav-prev",
                title: "Anterior",
                onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onPointerup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                onClick: _withModifiers(goPrev, ["stop"])
              }, [
                _createVNode(_unref(IonIcon), { icon: _unref(chevronBackOutline) }, null, 8, ["icon"])
              ], 32))
            : _createCommentVNode("", true),
          (currentFile.value && _unref(getViewerType)(currentFile.value.type ?? '') === 'pdf')
            ? (_openBlock(), _createBlock(PdfViewer, {
                key: 1,
                source: currentFile.value.source,
                id: "modal",
                zoomable: __props.zoomable,
                page: currentPage.value,
                onPageChanged: handlePageChanged
              }, null, 8, ["source", "zoomable", "page"]))
            : _createCommentVNode("", true),
          (currentFile.value && _unref(getViewerType)(currentFile.value.type) === 'video')
            ? (_openBlock(), _createBlock(VideoViewer, {
                key: 2,
                source: currentFile.value.source,
                zoomable: false
              }, null, 8, ["source"]))
            : _createCommentVNode("", true),
          (currentFile.value && _unref(getViewerType)(currentFile.value.type) === 'image')
            ? (_openBlock(), _createBlock(ImageViewer, {
                key: 3,
                source: currentFile.value.source,
                zoomable: __props.zoomable,
                rotation: rotation.value
              }, null, 8, ["source", "zoomable", "rotation"]))
            : _createCommentVNode("", true),
          (currentFile.value && _unref(getViewerType)(currentFile.value.type) === 'audio')
            ? (_openBlock(), _createBlock(AudioPlayer, {
                key: 4,
                "show-thumb": false,
                source: currentFile.value.source,
                type: currentFile.value.type,
                thumbnail: "/assets/Soundwave.svg",
                zoomable: false
              }, null, 8, ["source", "type"]))
            : _createCommentVNode("", true),
          (currentFile.value && _unref(getViewerType)(currentFile.value.type) === 'other')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true),
          (__props.enableWebCarousel && __props.files.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                type: "button",
                class: "carousel-nav carousel-nav-next",
                title: "Seguinte",
                onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                onPointerup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                onClick: _withModifiers(goNext, ["stop"])
              }, [
                _createVNode(_unref(IonIcon), { icon: _unref(chevronForwardOutline) }, null, 8, ["icon"])
              ], 32))
            : _createCommentVNode("", true),
          (__props.enableWebCarousel && __props.files.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(currentIndex.value + 1) + " / " + _toDisplayString(__props.files.length), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})